import axios from 'axios';

export class SettingsPharmacyService {
  static API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api/v1/`;

  static getGlovoEnabledStatus = async (sourceCode: string) => {
    const response = await axios({
      method: 'get',
      url: `${SettingsPharmacyService.API_BASE_URL}glovo/webhooks/store/close/${sourceCode}`,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  };

  static setEnambleGlovo = async (sourceCode: string) => {
    const response = await axios({
      method: 'delete',
      url: `${SettingsPharmacyService.API_BASE_URL}glovo/webhooks/store/close/${sourceCode}`,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  };

  static setDisableGlovo = async (sourceCode: string, until: string) => {
    const response = await axios({
      method: 'post',
      url: `${SettingsPharmacyService.API_BASE_URL}glovo/webhooks/store/close/${sourceCode}`,
      data: JSON.stringify({
        until,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  };
}
